const firebaseConfig = {
  apiKey: 'AIzaSyDUTJ30WzzSZg-zANRRtIlT9NDDTNVwxPU',
  authDomain: 'travel-guru-dca2a.firebaseapp.com',
  databaseURL: 'https://travel-guru-dca2a.firebaseio.com',
  projectId: 'travel-guru-dca2a',
  storageBucket: 'travel-guru-dca2a.appspot.com',
  messagingSenderId: '114407323924',
  appId: '1:114407323924:web:6b454c312dae5a58ac6a01',
};
export default firebaseConfig;